import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import GearBoxesView from '../views/GearBoxesView.vue'
import BodyTypesView from '../views/BodyTypesView.vue'
import FuelTypesView from '../views/FuelTypesView.vue'
import DriveTypesView from '../views/DriveTypesView.vue'
import EquipmentDB from '../views/EquipmentDB.vue'
import ColourDB from '../views/ColoursDB.vue'
import MakesDB from '../views/MakesDB.vue'
import ModelsDB from '../views/ModelsDB.vue'
import GenerationsDB from '../views/GenerationsDB.vue'
import PacketsDB from '../views/PacketsDB.vue'
import DealersDB from '../views/DealersDB.vue'
import CarList from '../views/CarList.vue'
import WebSettings from '../views/WebSettings.vue'
import ExportConfig from '../views/ExportConfig.vue'
import PublishingView from '../views/PublishingView.vue'
import CountriesView from '../views/CountriesView.vue'
import StatusesView from '../views/StatusesView.vue'
import DescriptionGeneratorsView from '../views/DescriptionGeneratorsView.vue'
import AccountSettings from '../views/AccountSettings.vue'
import InvoicesView from '../views/InvoicesView.vue'

const routes = [
    {
        path: '/admin/login',
        name: 'admin-login',
        component: LoginView,
        meta: { requiresAuth: false }
    },
    {
        path: '/admin',
        component: MainView,
        meta: { requiresAuth: true }, // Wszystkie podstrony wewnątrz dziedziczą ten warunek
        redirect: '/admin/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'admin-dashboard',
                component: DashboardView
            },
            {
                path: 'gearboxes',
                name: 'admin-gearboxes',
                component: GearBoxesView
            },
            {
                path: 'bodytypes',
                name: 'admin-bodytypes',
                component: BodyTypesView
            },
            {
                path: 'fueltypes',
                name: 'admin-fueltypes',
                component: FuelTypesView
            },
            {
                path: 'drivetypes',
                name: 'admin-drivetypes',
                component: DriveTypesView
            },
            {
                path: 'equipment',
                name: 'admin-equipment',
                component: EquipmentDB
            },
            {
                path: 'colours',
                name: 'admin-colours',
                component: ColourDB
            },
            {
                path: 'makes',
                name: 'admin-makes',
                component: MakesDB
            },
            {
                path: 'models',
                name: 'admin-models',
                component: ModelsDB
            },
            {
                path: 'generations',
                name: 'admin-generations',
                component: GenerationsDB
            },
            {
                path: 'packets',
                name: 'admin-packets',
                component: PacketsDB
            },
            {
                path: 'dealers',
                name: 'admin-dealers',
                component: DealersDB
            },
            {
                path: 'cars',
                name: 'admin-cars',
                component: CarList
            },
            {
                path: 'websettings',
                name: 'admin-websettings',
                component: WebSettings
            },
            {
                path: 'settings',
                name: 'admin-settings',
                component: AccountSettings
            },
            {
                path: 'export-config',
                name: 'export-config',
                component: ExportConfig
            },
            {
                path: 'publish',
                name: 'publish',
                component: PublishingView
            },
           {
                path: 'countries',
                name: 'countries',
                component: CountriesView
            },
          {
                path: 'statuses',
                name: 'statuses',
                component: StatusesView
            },
            {
                path: 'dgenerator',
                name: 'dgenerator',
                component: DescriptionGeneratorsView
            },
           {
                path: 'invoices',
                name: 'invoices',
                component: InvoicesView
            },
        ]
    },

    // 3. Domyślne przekierowanie z głównego adresu /
    {
        path: '/',
        redirect: '/admin/login'
    },

    // 4. Obsługa nieznanych adresów (404 / Catch-all)
    {
        path: '/:pathMatch(.*)*',
        redirect: () => {
            const token = localStorage.getItem('integrator_token')
            return token ? '/admin/dashboard' : '/admin/login'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// STRAŻNIK NAWIGACJI (Global Route Guard)
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('integrator_token')

    // Sprawdzamy, czy trasa LUB którakolwiek z jej tras nadrzędnych wymaga autoryzacji
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

    if (requiresAuth && !token) {
        next({ name: 'admin-login' })
    }
    else if (to.name === 'admin-login' && token) {
        next({ name: 'admin-dashboard' })
    }
    else {
        next()
    }
})

export default router